// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3YrDG","checkboxCol":"Table_checkboxCol__z-QiV","emailCol":"Table_emailCol__3eKG_","actionCol":"Table_actionCol__1GKDa"};